
import { defineComponent } from "vue";
import router from "@/router";
import {
  IStudentAttendanceSessionsModel,
} from "@/interfaces/modules";
import StudentAttendanceSessionsService from "@/api/Aula/StudentAttendanceSessionsService";

export default defineComponent({
  name: "StudentAttendanceSessionsContent",
  data() {
    return {
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "AcademicYearName", label: "Año académico", sortable: true },
          { key: "PeriodName", label: "Período", sortable: true },
          { key: "TeacherName", label: "Docente", sortable: true },
          { key: "CourseName", label: "Grupo", sortable: true },
          { key: "SubjectName", label: "Asignatura", sortable: true },
          { key: "HeadquarterName", label: "Sede", sortable: true },
          { key: "Date", label: "Fecha asistencia", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          {
            key: "ModifiedByFormat",
            label: "Última modificación",
            sortable: true,
          },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IStudentAttendanceSessionsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  async mounted() {
    await this.load();
  },
  computed: {
    filteredItems(): IStudentAttendanceSessionsModel[] {
      const search = (this.table.filters.search || "").toLowerCase();

      if (!search) return this.table.records;

      return this.table.records.filter((item: any) => {
        return (
          item.AcademicYearName?.toLowerCase().includes(search) ||
          item.HeadquarterName?.toLowerCase().includes(search) ||
          item.CourseGroupName?.toLowerCase().includes(search) ||
          item.Comments?.toLowerCase().includes(search)
        );
      });
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  methods: {
    async load() {
      this.table.loading = true;
      try {
        this.table.records =
          (await StudentAttendanceSessionsService.GetAll()) ||
          [];
      } finally {
        this.table.loading = false;
      }
    },
    /**
     * Nuevo llamado => sin Id
     * Ver/editar llamado => con Id (ajusta la ruta según tu configuración)
     */
    openForm(Id?: any) {
      router.push(`student-attendance-list/${Id}`);
    },
  },
});
